import type { SideBarItem, LegacyMenuItem } from './SideBar';

export function legacyMenuToSidebar(legacy: LegacyMenuItem[]): SideBarItem[] {
  // 1. Transformar em um map id -> item
  const map = new Map<string, SideBarItem & { id?: string; parentId?: string }>();
  legacy.forEach(item => {
    const id = item.id;
    const parentId = id.includes('.') ? id.split('.').slice(0, -1).join('.') : undefined;
    map.set(id, {
      label: item.menu,
      to: item.formulario ? `/registrar?view=${item.formulario}` : undefined,
      badge: item.tag as React.ReactNode,
      id,
      parentId,
      // subItems preenchido depois
    });
  });

  // 2. Montar a hierarquia
  const roots: SideBarItem[] = [];
  map.forEach(item => {
    if (item.parentId && map.has(item.parentId)) {
      const parent = map.get(item.parentId)!;
      parent.subItems = parent.subItems || [];
      parent.subItems.push(item);
    } else {
      roots.push(item);
    }
    // remover propriedades extras
    delete item.id;
    delete item.parentId;
  });
  return roots;
}